import React from 'react'
import { PromotedContent } from '../../../../components'
import { useSelector } from 'react-redux'
import { homeEnterpriseSlice } from '../../../../reducers'
import { MCoachPromo } from './mcoach-promo'
import { CategoryRails } from './category-rails'
import { Box } from '@mui/material'
import { WhatsNewRails } from './whats-new-rails'
import { QuizRails } from './quiz-rails'
import { BrowseByCategoriesRails } from './browse-by-categories-rails'
import { PromoteFeaturesRails } from './promote-features-rails'
import { OnboardingSection } from './onboarding-section'
import { SkillBitesRails } from './skill-bites-rails'
import { useHomeEnterpriseContext } from '../../context/home-enterprise-page-context'
import { RelatedLastReadRails } from './related-last-read-rails'
import { useTrackHomeEnterpriseEvent } from '../../hooks/useTrackHomeEnterpriseEvent'

export const HOME_SECTION_TYPE = {
  PROMOTED_CONTENT: 'promotedContent',
  CATEGORY: 'category',
  M_COACH: 'mCoach',
  PROMOTE_FEATURE: 'promoteFeature',
  SKILL_BITE: 'skillBite',
  WHATS_NEW: 'whatsNew',
  QUIZ: 'quiz',
  ONBOARDING: 'onboarding',
  BROWSE_BY_CATEGORIES: 'browseByCategories',
  RELATED_LAST_READ: 'relatedLastRead'
}

export const HomeSections = () => {
  const homePageSections = useSelector(homeEnterpriseSlice.selectors.selectHomePageSections)
  const homePageSectionsLoading = useSelector(homeEnterpriseSlice.selectors.selectHomePageSectionsLoading)
  const { showAddToPlaylist } = useHomeEnterpriseContext()
  const { trackArticleClickEvent } = useTrackHomeEnterpriseEvent()

  const renderSection = (section, index) => {
    if (section.type === HOME_SECTION_TYPE.PROMOTED_CONTENT) {
      return (
        <PromotedContent
          key={index}
          onCardSelect={(content, position) => {
            trackArticleClickEvent(section.type, content.locationId, {
              title: content.title,
              itemIndex: position
            })
          }}
          onAddToPlaylist={showAddToPlaylist}
          promotedContent={section.data}
          isLoading={homePageSectionsLoading}
        />
      )
    }

    if (section.type === HOME_SECTION_TYPE.M_COACH) {
      return (
        <Box key={index}>
          <MCoachPromo />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.CATEGORY) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <CategoryRails categorySection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.RELATED_LAST_READ) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <RelatedLastReadRails relatedLastReadSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.ONBOARDING) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <OnboardingSection />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.PROMOTE_FEATURE) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <PromoteFeaturesRails promoteFeaturesSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.SKILL_BITE) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <SkillBitesRails skillBitesSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.WHATS_NEW) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <WhatsNewRails whatsNewSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.QUIZ) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <QuizRails quizSection={section.data} />
        </Box>
      )
    }

    if (section.type === HOME_SECTION_TYPE.BROWSE_BY_CATEGORIES) {
      return (
        <Box key={index} sx={{ display: 'grid' }}>
          <BrowseByCategoriesRails browseByCategoriesSection={section.data} />
        </Box>
      )
    }

    return null
  }

  return (
    <Box
      data-test='home-page-sections-container'
      sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}
    >
      {homePageSections.map(renderSection)}
    </Box>
  )
}
